"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SendReviewComponent = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _ConfirmEmailCheckbox = _interopRequireDefault(require("../ConfirmEmailCheckbox/ConfirmEmailCheckbox"));

var _useGiftContext2 = require("../../hooks/useGiftContext");

var _useEmailPreview = require("../../hooks/useEmailPreview");

var _gift = require("../../store/gift/gift.selector");

var postcardActions = _interopRequireWildcard(require("../../store/gift/postcard/message/message.actions"));

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _invitationType = require("../../store/gift/invitationType/invitationType.selectors");

var _EmailIntegrationBroken = _interopRequireDefault(require("../../containers/EmailIntegration/EmailIntegrationBroken"));

var _features = require("../../../Shared/store/features");

var _constants = require("../../constants");

var _SendGiftButton = _interopRequireDefault(require("./SendGiftButton"));

var _GiftQuantity = _interopRequireDefault(require("./GiftQuantity"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    root: {
      padding: spacing(3),
      paddingRight: spacing(2),
      paddingLeft: spacing(6)
    },
    invitations: {
      padding: spacing(3, 0)
    },
    buttonIcon: {
      marginRight: spacing(1),
      color: 'inherit'
    },
    disabled: {
      opacity: 0.5,
      pointerEvents: 'none'
    },
    eyeIcon: {
      color: palette.link.main,
      marginRight: 5
    },
    previewButton: {
      padding: 0,
      '&:hover': {
        textDecoration: 'underline',
        backgroundColor: 'transparent'
      }
    }
  };
});

var SendReviewComponent = function SendReviewComponent(_ref2) {
  var remainingInvites = _ref2.remainingInvites,
      disabled = _ref2.disabled,
      recipientLandingPage = _ref2.recipientLandingPage,
      profileName = _ref2.profileName,
      error = _ref2.error,
      isAlyceGiftCard = _ref2.isAlyceGiftCard;
  var dispatch = (0, _reactRedux.useDispatch)();
  var trackMessagePreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowMessagePreviewClicked)();
  var trackLandingPreview = (0, _useTrackGiftingFlow.useTrackGiftingFlowLandingPreviewClicked)();

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      sidebarMode = _useGiftContext.sidebarMode;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isConfirmed = _useState2[0],
      setIsConfirmed = _useState2[1];

  var classes = useStyles();
  var emailProviderId = (0, _reactRedux.useSelector)(_gift.getGiftEmailProviderId);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var isLinkInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedLinkInvitationType);
  var isDirectMailInvitationType = (0, _reactRedux.useSelector)(_invitationType.getIsSelectedDirectMailInvitationType);
  var quantity = (0, _reactRedux.useSelector)(_gift.getGiftQuantity);
  var emailLink = (0, _useEmailPreview.useEmailPreview)();
  var isEmailPreviewVisible = !isAlyceGiftCard && !isLinkInvitationType;
  var isLandingPreviewVisible = !isAlyceGiftCard;
  var isPreviewButtonsVisible = !isDirectMailInvitationType && (isEmailPreviewVisible || isLandingPreviewVisible);
  var isValidQuantity = R.gte(quantity, _constants.DEFAULT_GIFT_QUANTITY);
  var isIntegrationWarningVisible = (0, _reactRedux.useSelector)(_gift.getIsBrokenIntegrationWarningVisible);
  var hasBudgetManagementLimit = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_LIMIT));
  var hasBudgetManagementSetup = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.BUDGET_MANAGEMENT_SETUP));
  var hasBudgetFeaturesEnabled = hasBudgetManagementLimit && hasBudgetManagementSetup;
  var onEmailPreview = (0, _react.useCallback)(function () {
    trackMessagePreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.SEND_GIFT);

    if (sidebarMode) {
      window.open(emailLink, '_blank');
    } else {
      dispatch(postcardActions.openCustomPreview({
        isVisible: true,
        emailProviderId,
        giftId
      }));
    }
  }, [dispatch, emailLink, emailProviderId, giftId, sidebarMode, trackMessagePreview]);
  var previewLandingPageHandler = (0, _react.useCallback)(function () {
    trackLandingPreview(_useTrackGiftingFlow.GIFTING_TRACK_STEPS.SEND_GIFT);
  }, [trackLandingPreview]);
  var trackConfirmed = (0, _useTrackGiftingFlow.useTrackGiftingFlowConfirmationCheckboxPassed)();
  var handleConfirmed = (0, _react.useCallback)(function () {
    if (!isConfirmed) {
      trackConfirmed();
    }

    setIsConfirmed(!isConfirmed);
  }, [isConfirmed, trackConfirmed]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    "aria-label": "hands up"
  }, "\uD83D\uDE4C"), ' ', "Last step! Review and confirm your choices"), isIntegrationWarningVisible && /*#__PURE__*/_react.default.createElement(_EmailIntegrationBroken.default, {
    mt: 3
  }), !R.isNil(remainingInvites) && !hasBudgetFeaturesEnabled && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Static-Bold', classes.invitations)
  }, "Your Invitations: ", /*#__PURE__*/_react.default.createElement("span", {
    className: "Body-Regular-Left-Success-Bold"
  }, remainingInvites, " left")), isPreviewButtonsVisible && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "flex-start"
  }, isEmailPreviewVisible && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    onClick: onEmailPreview,
    className: (0, _classnames.default)('Body-Regular-Center-Link-Bold', classes.previewButton),
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      color: "inherit",
      icon: "eye"
    })
  }, "View your message")), isLandingPreviewVisible && /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: recipientLandingPage,
    underline: "hover",
    onClick: previewLandingPageHandler,
    target: "_blank",
    className: (0, _classnames.default)(recipientLandingPage ? '' : classes.disabled, 'Body-Regular-Center-Link-Bold')
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    className: classes.eyeIcon,
    icon: "eye"
  }), "View your landing page")), isDirectMailInvitationType && /*#__PURE__*/_react.default.createElement(_GiftQuantity.default, null), /*#__PURE__*/_react.default.createElement(_ConfirmEmailCheckbox.default, {
    name: profileName,
    value: isConfirmed,
    onChange: handleConfirmed
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    pt: 4
  }, /*#__PURE__*/_react.default.createElement(_SendGiftButton.default, {
    disabled: disabled || !isConfirmed || !isValidQuantity
  })), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !!error
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    pt: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    className: "Body-Regular-Left-Error"
  }, error)));
};

exports.SendReviewComponent = SendReviewComponent;
SendReviewComponent.propTypes = {
  remainingInvites: _propTypes.default.number,
  disabled: _propTypes.default.bool.isRequired,
  profileName: _propTypes.default.string.isRequired,
  recipientLandingPage: _propTypes.default.string,
  error: _propTypes.default.string,
  isAlyceGiftCard: _propTypes.default.bool.isRequired
};
SendReviewComponent.defaultProps = {
  remainingInvites: null,
  recipientLandingPage: '',
  error: ''
};
var _default = SendReviewComponent;
exports.default = _default;